import script from "./RangeChart.vue?vue&type=script&lang=js"
export * from "./RangeChart.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__